export const CONTACT_METHODS = {
  MOBILE: 'Mobile',
  EMAIL: 'Email',
  PHONE: 'Phone',
  FAX: 'Fax',
}

export const CONTACT_METHOD_TYPES = {
  PERSONAL: 'Personal',
  WORK: 'Work',
}

const { PERSONAL, WORK } = CONTACT_METHOD_TYPES

export const METHOD_TYPES = {
  Email: [PERSONAL, WORK],
  Phone: [PERSONAL, WORK],
  Mobile: [PERSONAL, WORK],
  Fax: [WORK],
}

// Method types that carry a phone extension. Used by the form (to gate the
// Extension input + clear-on-method-change), by the display (to gate the
// "Ext. …" suffix and the DTMF tel: pause), and anywhere else that needs to
// answer the question "does this method support a phone extension?".
export const PHONE_EXTENSION_METHODS = [CONTACT_METHODS.PHONE, CONTACT_METHODS.MOBILE]

export const supportsPhoneExtension = methodType => PHONE_EXTENSION_METHODS.includes(methodType)
